import { FormattedMessage, useIntl } from 'react-intl';
import React, { useContext } from 'react';
import { useModal } from 'store/modals';
import { useDeleteZone } from 'services/2n/zones/delete-zone';
import { DeleteButton } from '../../../../../../../../../form-elements/buttons/DeleteButton';
import { AccessManagement2NModalContext } from '../../../AccessManagement2NModalContext';

export const DeleteResource = () => {

  const intl = useIntl();
  const { openModal } = useModal();
  const { selectedResource, setSelectedResource } = useContext(AccessManagement2NModalContext);

  const { deleteZone } = useDeleteZone({
    onSuccess: () => {
      setSelectedResource(null);
    },
  });

  function onDeleteResource() {
    openModal({
      modalType: 'ConfirmationModal',
      modalProps: {
        title: intl.formatMessage(
          {
            id: 'deleteResourceConfirm',
          },
        ),
        content: intl.formatMessage(
          {
            id: 'deleteResourceConfirmContent',
          },
        ),
        onConfirm: () => deleteZone(selectedResource.id),
      },
    });
  }

  return (

    <DeleteButton
      intl="deleteResourcePermanently"
      onClick={() => onDeleteResource()}
    >
      <FormattedMessage id="deleteResourcePermanently" />
    </DeleteButton>
   
  );
};
